import React from "react";
import { hotel } from "../mock";

// WhatsApp brand icon (inline SVG - lucide has no brand logo)
export const WhatsAppIcon = ({ size = 30 }) => (
  <svg viewBox="0 0 32 32" width={size} height={size} fill="currentColor" aria-hidden="true">
    <path d="M16.01 3.2c-7.05 0-12.78 5.72-12.78 12.77 0 2.25.59 4.45 1.71 6.39L3.2 28.8l6.6-1.72a12.73 12.73 0 0 0 6.2 1.58h.01c7.04 0 12.77-5.72 12.77-12.77 0-3.41-1.33-6.62-3.74-9.03A12.68 12.68 0 0 0 16.01 3.2Zm0 23.35h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.62 10.63-10.62 2.84 0 5.5 1.11 7.51 3.12a10.55 10.55 0 0 1 3.11 7.51c0 5.86-4.77 10.63-10.63 10.63Zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55-.18-.01-.4-.01-.61-.01-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65 0 1.56 1.14 3.07 1.3 3.28.16.21 2.25 3.43 5.44 4.81.76.33 1.35.52 1.81.67.76.24 1.46.21 2 .13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z" />
  </svg>
);

// Build a wa.me link with a pre-filled message
export const waUrl = (message) =>
  `https://wa.me/${hotel.whatsapp}?text=${encodeURIComponent(message)}`;

// Desktop-only floating round button (hidden on mobile; sticky bar used there)
const WhatsAppButton = () => (
  <a
    href={waUrl(`${hotel.whatsappIntro} Müsaitlik ve fiyat bilgisi rica ediyorum.`)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="WhatsApp ile hızlı rezervasyon"
    className="wa-fab group"
  >
    <span className="wa-fab-label">Rezervasyon için yazın</span>
    <span className="wa-fab-btn">
      <WhatsAppIcon size={30} />
    </span>
  </a>
);

export default WhatsAppButton;
